<template>
  <v-row justify="start" class="flex-nowrap pa-0 ma-0">
    <v-col
      v-if="notExact"
      cols="auto pa-0 mr-1"
      :title="mess['legend_not_exact']"
    >
      <v-icon size="20" color="red">mdi-alert-octagram-outline</v-icon>
    </v-col>

    <v-col
      v-if="isKit"
      @click="$emit('assembly-click')"
      cols="auto pa-0 mr-1"
      style="cursor: pointer"
      :title="mess['legend_assembly']"
    >
      <v-icon size="16">widgets</v-icon>
    </v-col>

    <v-col v-if="isAnalog" cols="auto pa-0 mr-1" :title="mess['legend_analog']">
      <v-icon size="16">mdi-content-copy</v-icon>
    </v-col>

    <v-col
      v-if="haveOnStorage"
      cols="auto pa-0 mr-1"
      :title="mess['legend_item_on_store']"
    >
      <v-icon size="16">mdi-warehouse</v-icon>
    </v-col>

    <v-col
      v-if="haveAnalogOnStorage"
      cols="auto pa-0 mr-1"
      :title="mess['legend_analog_on_store']"
    >
      <v-icon size="16">mdi-checkbox-multiple-outline</v-icon>
    </v-col>

    <v-col
      v-if="inTransit"
      cols="auto pa-0 mr-1"
      :title="mess['legend_transit']"
    >
      <v-icon size="16">mdi-ferry</v-icon>
    </v-col>

    <v-col
      v-if="salesDraw"
      cols="auto pa-0"
      :title="mess['legend_sales_draft']"
    >
      <v-icon size="16">mdi-android-studio</v-icon>
    </v-col>

    <v-col v-if="withFile" cols="auto pa-0" :title="mess['legend_file']">
      <v-icon size="19" style="transform: rotate(90deg)">mdi-attachment</v-icon>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ArticleIcons",
  props: {
    haveAnalogOnStorage: {
      type: Boolean,
      default: false
    },
    haveOnStorage: {
      type: Boolean,
      default: false
    },
    inTransit: {
      type: Boolean,
      default: false
    },
    isAnalog: {
      type: Boolean,
      default: false
    },
    isKit: {
      type: Boolean,
      default: false
    },
    salesDraw: {
      type: Boolean,
      default: false
    },
    notExact: {
      type: Boolean,
      default: false
    },
    withFile: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped></style>
